<template>
  <div id="directory-banners-gallery">
    <div class="column-container">
      <time-travel v-if="showTimeTravel"></time-travel>
    </div>

    <gallery-section
      v-for="(section, i) in sections"
      :key="i"
      :section="section"
      :compact="true"
    ></gallery-section>
  </div>
</template>

<script>
import GallerySection from './GallerySection.vue';
import TimeTravel from './TimeTravel.vue';
import GallerySectionConfig from '../structure/Configuration/GallerySectionConfig';
import GallerySectionResource from '../structure/Resources/GallerySection';
import Gallery from '../structure/Resources/Gallery';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['currentResource']),

    showTimeTravel() {
      return this.currentResource
        .children()
        .some(c => c.isBanner() && !c.isStatic() && c.config().timetravel());
    },

    sections() {
      const gallery = new Gallery(this.currentResource);

      return this.currentResource
        .children()
        .filter(c => c.isBanner())
        .sort(
          (a, b) =>
            (b.width() ?? 0) - (a.width() ?? 0) ||
            (b.height() ?? 0) - (a.height() ?? 0)
        )
        .map(banner => {
          const name =
            banner.width() && banner.height()
              ? `${banner.width()}×${banner.height()}`
              : banner.name();

          return new GallerySectionResource(
            new GallerySectionConfig({
              stack: true,
              banners: [{ basename: banner.basename(), caption: name }],
            }),
            gallery
          );
        });
    },
  },

  components: {
    GallerySection,
    TimeTravel,
  },
};
</script>

<style lang="scss" scoped>
#directory-banners-gallery {
  padding: 1rem;

  .column-container {
    margin-bottom: 3rem;
  }
}
</style>
